export const STORAGE_KEYS_CROSS_USERS: StorageKey[] = [
  'THEME',
  'BOD_TIMESTAMP',
  'LAST_CLEARED_VERSION',
  'DEVICE_UUID_FINGER_PRINT_PRO',
];

export const STORAGE_KEY_ALL_USERS = 'DATA';

/*
  Example:
  [
    {
      version: '1.43.1',
      keys: ['IQ_CHART_LAYOUT'],
    },
  ]
*/
export const CLEAR_REQUIRED_KEYS: {
  version: string;
  keys: StorageKey[];
}[] = [];
